/** {@link https://www.kucoin.com/docs/basic-info/base-url} */
export const kucoinApiEndpoint = 'https://api.kucoin.com'

/** {@link https://www.kucoin.com/docs/basic-info/base-url} */
export const kucoinFuturesApiEndpoint = 'https://api-futures.kucoin.com'

// TODO 定期的に KuCoin の対応チェーン情報を確認して更新する
export const supportChains = [
  'eth',
  'loki',
  'nrg',
  'xlm',
  'xmr',
  'rbtc',
  'bsc',
  'trtl',
  'kcc',
  'kmd',
  'nix',
  'tt',
  'atom',
  'nimpos',
  'coti',
  'pivx',
  'xtz',
  'bnb',
  'algo',
  'ada',
  'nem',
  'zec',
  'sero',
  'eosc',
  'derohe',
  'trx',
  'waxp',
  'enq',
  'theta',
  'one',
  'iost',
  'terra',
  'luna',
  'mxw',
  'sxp',
  'cos',
  'ksm',
  'xns',
  'zel',
  'axe',
  'steem',
  'xdbchain',
  'stx',
  'waves',
  'kai',
  'dot',
  'ewt',
  'west',
  'nuls',
  'luk',
  'vet',
  'eos',
  'ckb2',
  'arbitrum',
  'uos',
  'kts',
  'fil',
  'bchabc',
  'oasis',
  'xhv',
  'htr',
  'hydra',
  'lunc',
  'dfi',
  'zil',
  'zen',
  'klv',
  'doge',
  'matic',
  'heco',
  'orai',
  'pha',
  'avax',
  'avaxc',
  'tara',
  'xym',
  'pcx',
  'flux',
  'pdex',
  'xdc',
  'kda',
  'icp',
  'celo',
  'glq',
  'tlosevm',
  'tlos',
  'mxc',
  'apl',
  'divi',
  'jup',
  'abbc',
  'arrr',
  'ngm',
  'near',
  'cfg',
  'route',
  'kar',
  'ergo',
  'sol',
  'xch',
  'mtl',
  'xpr',
  'movr',
  'sdn',
  'ndau',
  'dydx',
  'hbar',
  'xprt',
  'egld',
  'flow',
  'band',
  'dvpn',
  'edg',
  'statemine',
  'rune',
  'inj',
  'ar',
  'lto',
  'meter',
  'kava',
  'vlx',
  'vlxevm',
  'kavaevm',
  'lit',
  'kma',
  'klay',
  'xec',
  'iota',
  'glmr',
  'astr',
  'aca',
  'nano',
  'metis',
  'bncdot',
  'bnc',
  'cfxcore',
  'cfx',
  'base',
  'fra',
  'aurora',
  'psl',
  'sysevm',
  'brise',
  'akt',
  'fsn',
  'boba',
  'ont',
  'ccd',
  'scrt',
  'optimism',
  'ever',
  'icx',
  'cspr',
  'wemix',
  'radix',
  'dogechain',
  'neer',
  'rvn',
  'cmp',
  'pix',
  'ethw',
  'pokt',
  'efi',
  'aptos',
  'ton',
  'azero',
  'oas',
  'osmo',
  'flare',
  'bdx',
  'mina',
  'hmnd',
  'nom',
  'straxevm',
  'ironfish',
  'zksync2',
  'sui',
  'kas',
  'tenet',
  'xpll',
  'btc',
  'sei',
  'omn',
  'lukso',
  'haqq',
  'ntrn',
  'tia',
  'polymesh',
  'mnt',
  'tao',
  'manta',
  'zeta',
  'dym',
  'starknet',
  'merlin',
  'nibiru',
  'partisia',
  'venom',
  'linea',
  'mapo',
  'bb',
  'taiko',
  'oort',
  'blast',
  'slf',
  'smh',
  'zkl',
  'avail',
  'bft',
  'scroll',
  'peaq',
  'lumia',
  'btf',
  'zrc',
  'supra',
  'xion',
  'hype',
  'vsys',
  'neo',
  'actevm',
  'aion',
  'amb',
  'aoa',
  'bcd',
  'bchn',
  'bchsv',
  'bhc',
  'bos',
  'btcln',
  'bech32',
  'btcp',
  'btg',
  'btm',
  'bu',
  'cpc',
  'cs',
  'dag',
  'dash',
  'dcr',
  'dgb',
  'dock',
  'esc',
  'ela',
  'enj',
  'etc',
  'etnevm',
  'ftm',
  'zpt',
  'neon3',
  'go',
  'god',
  'hc',
  'hpb',
  'iotx',
  'itc',
  'ltc',
  'man',
  'meta',
  'nebl',
  'olt',
  'onion',
  'pal',
  'pura',
  'qkc',
  'qtum',
  'rhoc',
  'phantasma',
  'sphtx',
  'tomo',
  'statemint',
  'noble',
  'ut',
  'wan',
  'wtc',
  'xas',
  'xlr',
  'xrp',
  'grin',
  'mhc',
] as const
export type SupportChain = (typeof supportChains)[number]
export const supportSolanaChainName = 'sol' satisfies SupportChain
export const supportChainEvmChainIds: {
  [chain in SupportChain]: number | undefined
} = {
  eth: 1,
  loki: undefined,
  nrg: undefined,
  xlm: undefined,
  xmr: undefined,
  rbtc: undefined,
  bsc: 56,
  trtl: undefined,
  kcc: undefined,
  kmd: undefined,
  nix: undefined,
  tt: undefined,
  atom: undefined,
  nimpos: undefined,
  coti: undefined,
  pivx: undefined,
  xtz: undefined,
  bnb: undefined,
  algo: undefined,
  ada: undefined,
  nem: undefined,
  zec: undefined,
  sero: undefined,
  eosc: undefined,
  derohe: undefined,
  trx: undefined,
  waxp: undefined,
  enq: undefined,
  theta: undefined,
  one: undefined,
  iost: undefined,
  terra: undefined,
  luna: undefined,
  mxw: undefined,
  sxp: undefined,
  cos: undefined,
  ksm: undefined,
  xns: undefined,
  zel: undefined,
  axe: undefined,
  steem: undefined,
  xdbchain: undefined,
  stx: undefined,
  waves: undefined,
  kai: undefined,
  dot: undefined,
  ewt: undefined,
  west: undefined,
  nuls: undefined,
  luk: undefined,
  vet: undefined,
  eos: undefined,
  ckb2: undefined,
  arbitrum: 42_161,
  uos: undefined,
  kts: undefined,
  fil: undefined,
  bchabc: undefined,
  oasis: undefined,
  xhv: undefined,
  htr: undefined,
  hydra: undefined,
  lunc: undefined,
  dfi: undefined,
  zil: undefined,
  zen: undefined,
  klv: undefined,
  doge: undefined,
  matic: 137,
  heco: undefined,
  orai: undefined,
  pha: undefined,
  avax: undefined,
  avaxc: 43_114,
  tara: undefined,
  xym: undefined,
  pcx: undefined,
  flux: undefined,
  pdex: undefined,
  xdc: undefined,
  kda: undefined,
  icp: undefined,
  celo: undefined,
  glq: undefined,
  tlosevm: undefined,
  tlos: undefined,
  mxc: undefined,
  apl: undefined,
  divi: undefined,
  jup: undefined,
  abbc: undefined,
  arrr: undefined,
  ngm: undefined,
  near: undefined,
  cfg: undefined,
  route: undefined,
  kar: undefined,
  ergo: undefined,
  sol: undefined,
  xch: undefined,
  mtl: undefined,
  xpr: undefined,
  movr: 1285,
  sdn: undefined,
  ndau: undefined,
  dydx: undefined,
  hbar: undefined,
  xprt: undefined,
  egld: undefined,
  flow: undefined,
  band: undefined,
  dvpn: undefined,
  edg: undefined,
  statemine: undefined,
  rune: undefined,
  inj: undefined,
  ar: undefined,
  lto: undefined,
  meter: undefined,
  kava: undefined,
  vlx: undefined,
  vlxevm: undefined,
  kavaevm: undefined,
  lit: undefined,
  kma: undefined,
  klay: undefined,
  xec: undefined,
  iota: undefined,
  glmr: 1284,
  astr: undefined,
  aca: undefined,
  nano: undefined,
  metis: 1088,
  bncdot: undefined,
  bnc: undefined,
  cfxcore: undefined,
  cfx: undefined,
  base: 8453,
  fra: undefined,
  aurora: undefined,
  psl: undefined,
  sysevm: undefined,
  brise: undefined,
  akt: undefined,
  fsn: undefined,
  boba: undefined,
  ont: undefined,
  ccd: undefined,
  scrt: undefined,
  optimism: 10,
  ever: undefined,
  icx: undefined,
  cspr: undefined,
  wemix: undefined,
  radix: undefined,
  dogechain: 2000,
  neer: undefined,
  rvn: undefined,
  cmp: undefined,
  pix: undefined,
  ethw: undefined,
  pokt: undefined,
  efi: undefined,
  aptos: undefined,
  ton: undefined,
  azero: undefined,
  oas: 248,
  osmo: undefined,
  flare: undefined,
  bdx: undefined,
  mina: undefined,
  hmnd: undefined,
  nom: undefined,
  straxevm: undefined,
  ironfish: undefined,
  zksync2: 324,
  sui: undefined,
  kas: undefined,
  tenet: undefined,
  xpll: undefined,
  btc: undefined,
  sei: undefined,
  omn: undefined,
  lukso: undefined,
  haqq: undefined,
  ntrn: undefined,
  tia: undefined,
  polymesh: undefined,
  mnt: 5000,
  tao: undefined,
  manta: 169,
  zeta: undefined,
  dym: undefined,
  starknet: undefined,
  merlin: undefined,
  nibiru: undefined,
  partisia: undefined,
  venom: undefined,
  linea: 59_144,
  mapo: undefined,
  bb: undefined,
  taiko: undefined,
  oort: undefined,
  blast: 81457,
  slf: undefined,
  smh: undefined,
  zkl: undefined,
  avail: undefined,
  bft: undefined,
  scroll: 534_352,
  peaq: undefined,
  lumia: undefined,
  btf: undefined,
  zrc: undefined,
  supra: undefined,
  xion: undefined,
  hype: undefined,
  vsys: undefined,
  neo: undefined,
  actevm: undefined,
  aion: undefined,
  amb: undefined,
  aoa: undefined,
  bcd: undefined,
  bchn: undefined,
  bchsv: undefined,
  bhc: undefined,
  bos: undefined,
  btcln: undefined,
  bech32: undefined,
  btcp: undefined,
  btg: undefined,
  btm: undefined,
  bu: undefined,
  cpc: undefined,
  cs: undefined,
  dag: undefined,
  dash: undefined,
  dcr: undefined,
  dgb: undefined,
  dock: undefined,
  esc: undefined,
  ela: undefined,
  enj: undefined,
  etc: undefined,
  etnevm: undefined,
  ftm: 250,
  zpt: undefined,
  neon3: undefined,
  go: undefined,
  god: undefined,
  hc: undefined,
  hpb: undefined,
  iotx: undefined,
  itc: undefined,
  ltc: undefined,
  man: undefined,
  meta: undefined,
  nebl: undefined,
  olt: undefined,
  onion: undefined,
  pal: undefined,
  pura: undefined,
  qkc: undefined,
  qtum: undefined,
  rhoc: undefined,
  phantasma: undefined,
  sphtx: undefined,
  tomo: undefined,
  statemint: undefined,
  noble: undefined,
  ut: undefined,
  wan: undefined,
  wtc: undefined,
  xas: undefined,
  xlr: undefined,
  xrp: undefined,
  grin: undefined,
  mhc: undefined,
}
export const isSupportChain = (chain: string): chain is SupportChain =>
  supportChains.includes(chain as SupportChain)
